(function($) {

  $('footer .fa.fa-facebook').on("click", function(){
		dataLayer.push({
			'event': 'gaEvent',
			'eventCategory': 'Interface',
			'eventAction': 'Icône réseau social',
			'eventLabel': 'Clic vers Facebook',
			'eventValue': '1'		// Fonctionnement : on envoie la valeur "1", il ne peut pas y avoir plus
		});
  });

  $('footer .fa.fa-twitter').on("click", function(){
		dataLayer.push({
			'event': 'gaEvent',
			'eventCategory': 'Interface',
			'eventAction': 'Icône réseau social',
			'eventLabel': 'Clic vers Twitter',
			'eventValue': '1'		// Fonctionnement : on envoie la valeur "1", il ne peut pas y avoir plus
		});
  });


  $('.ssba_pinterest_share').on("click", function(){
  		dataLayer.push({
			'event': 'social',
			'socialNetwork': 'pinterest',// Le réseau social où l'action a lieu (Facebook, Twitter, etc.)
			'socialAction': 'partage', // L'action effectuée (like, tweet, pin, etc.)
			'socialTarget': window.location.href,	// L'URL partagée											
			
		});
  });

  $('.btn-booking-sidebar').on("click", function(){
  		dataLayer.push({
			'event': 'gaEvent',
			'eventCategory': 'Button',
			'eventAction': 'Reserver',
			'eventLabel': undefined,// Il s'agit bien d'une réinitialisation de la variable, pas de la chaîne "undefined"
			'eventValue': undefined	// Il s'agit bien d'une réinitialisation de la variable, pas de la chaîne "undefined"										
			
		});
  });

 
  	document.addEventListener( 'wpcf7mailsent', function( event ) {

  			switch(event.detail.contactFormId){

  				case "193":
  					dataLayer.push({
						'event': 'gaEvent',
						'eventCategory': 'Formulaire',
						'eventAction': 'Demande de contact',
						'eventLabel': '',	// Indiquer ici le sujet de la demande de contact, si applicable; sinon laisser vide
						'eventValue': '1'	// Fonctionnement : on envoie la valeur "1", il ne peut pas y avoir plus

					});
  					break;

  				case "254":
  					dataLayer.push({
						'event': 'gaEvent',
						'eventCategory': 'Formulaire',
						'eventAction': 'Demande de rappel',	
						'eventLabel': '', // Indiquer ici si l'utilisateur a cliqué sur le bloc en haut ou en bas de homepage
						'eventValue': '1'	// Fonctionnement : on envoie la valeur "1", il ne peut pas y avoir plus	

					});
  					break;

  				case "45":
  					dataLayer.push({
						'event': 'gaEvent',
						'eventCategory': 'Formulaire',
						'eventAction': 'Demande de domiciliation',	
						'eventLabel': 'Depuis Formulaire Haut HomePage',	// Indiquer ici si l'utilisateur a cliqué sur le bloc en haut ou en bas de homepage
						'eventValue': '1'	// Fonctionnement : on envoie la valeur "1", il ne peut pas y avoir plus	

					});
  					break;


  				case "192":
  					dataLayer.push({
						'event': 'gaEvent',
						'eventCategory': 'Formulaire',
						'eventAction': 'Demande de domiciliation',	
						'eventLabel': 'Depuis Formulaire Bas HomePage',	// Indiquer ici si l'utilisateur a cliqué sur le bloc en haut ou en bas de homepage
						'eventValue': '1'	// Fonctionnement : on envoie la valeur "1", il ne peut pas y avoir plus	

					});
  					break;
  			}
			
	}, false );

})(jQuery);
